<template>
<section class="concept-section _preview-section">

    <div class="section-inner">
        <div class="concept-item">
            <h2 class="heading-section"><span></span> Concept</h2>
            <p>{{ $store.state.register.form.concept }}</p>
        </div>
    </div>

</section><!--/.page-name-row-->
</template>
